"use client";

import React from "react";
import { Linkedin, Twitter, Instagram, Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const businessName = "Feel Good Works";
const mission = "A UK-based consultancy specialising in workplace wellbeing diagnostics, strategy, and practical support to improve organisational health and employee resilience.";
const services = ["Wellbeing Risk Radar", "Workplace Wellbeing Audits", "Training and Workshops", "Speaking and Advisory Support"];
const email = "info@feelgoodworks.co.uk";
const phone = "To be provided";
const socials = [{
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="font-sans text-foreground/90 hover:text-chart-3 transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark text-foreground pt-20 pb-8 px-6 md:px-12 lg:px-24 bg-secondary">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="inline-block mb-6">
              <img src="/img/feel_good_works_logo_white.png" alt="Feel Good Works Logo" className="h-7 w-auto object-contain" src="https://guiding-panda.10web.cloud/wp-content/uploads/2026/05/FGW-Logo-White-Transp.png" />
            </Link>
            <p className="font-sans text-foreground/80 leading-relaxed text-sm md:text-base pr-4">
              {mission}
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 text-foreground">Quick Links</h3>
            <MenuProvider menu_id="31">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 text-foreground">Services</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="#" className="font-sans text-foreground/90 hover:text-chart-3 transition-colors duration-200">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-lg mb-6 text-foreground">Immediate Action</h3>
            <div className="flex flex-col gap-6">
              <div className="space-y-3">
                <Link to={`mailto:${email}`} className="flex items-center gap-3 font-sans text-foreground/90 hover:text-chart-3 transition-colors group">
                  <Mail className="size-5 text-chart-3 group-hover:text-foreground transition-colors" />
                  <span>{email}</span>
                </Link>
                {phone !== "To be provided" && phone !== "" && <Link to={`tel:${phone}`} className="flex items-center gap-3 font-sans text-foreground/90 hover:text-chart-3 transition-colors group">
                    <Phone className="size-5 text-chart-3 group-hover:text-foreground transition-colors" />
                    <span>{phone}</span>
                  </Link>}
              </div>
              
              <Button variant="default" className="w-fit font-default font-bold rounded-lg px-8" asChild>
                <Link to="#">
                  Get in Touch
                </Link>
              </Button>

              <div className="flex gap-4 pt-2">
                {socials.map((social, i) => <Link key={i} data-index={i} to={social.href} className="bg-muted/20 p-2 rounded-lg text-foreground hover:bg-chart-3 hover:text-background transition-all duration-300">
                    <social.icon className="size-5" />
                  </Link>)}
              </div>
            </div>
          </div>

        </div>

        {}
        <div className="pt-8 border-t border-chart-3/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-sans font-bold text-sm text-foreground/70">
            &copy; {currentYear} {businessName}. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="font-sans font-bold text-sm text-foreground/70 hover:text-chart-3 transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="font-sans font-bold text-sm text-foreground/70 hover:text-chart-3 transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}